export const UPSELL_CLICKED = 'EditorProofing_UpsellClicked';
